// src/pages/AdminDashboard.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminDashboard.css";
import apiClient from "../utils/apiClient";
import SessionHandler from "../components/SessionHandler";

const AdminDashboard = () => {
  const navigate = useNavigate();

  const [pendingLeaveCount, setPendingLeaveCount] = useState(0);
  const [totalLeaveCount, setTotalLeaveCount] = useState(0);
  const [pendingWFHCount, setPendingWFHCount] = useState(0);
  const [pendingResignationRequests, setPendingResignationRequests] = useState(0);
  const [pendingSalarySlipRequests, setPendingSalarySlipRequests] = useState(0);
  const [employeeCount, setEmployeeCount] = useState(0);
  const [pendingCFLeaveCount, setPendingCFLeaveCount] = useState(0);

  // ✅ FIXED useEffect
  useEffect(() => {
    fetchDashboardData();
  }, );

  const fetchDashboardData = async () => {
    try {
      await Promise.all([
        fetchLeaveCounts(),
        fetchPendingWFHCount(),
        fetchResignationRequests(),
        fetchSalarySlipRequests(),
        fetchEmployeeCount(),
        fetchPendingCFLeaveCount(),
      ]);
    } catch (err) {
      console.error("Dashboard data fetch failed:", err);
    }
  };

  // ================= CF LEAVE =================
  const fetchPendingCFLeaveCount = async () => {
    try {
      const data = await apiClient("/cfleaves/approval/");
      if (!data) return;

      const list = Array.isArray(data) ? data : data.results || [];
      const pendingCF = list.filter((req) => req.status === "Pending").length;

      setPendingCFLeaveCount(pendingCF);
    } catch (error) {
      console.error("Error fetching CF leave requests:", error);
    }
  };

  // ================= LEAVE =================
  const fetchLeaveCounts = async () => {
    try {
      const data = await apiClient("/leaves/");
      if (!data) return;

      const results = Array.isArray(data.results)
        ? data.results
        : Array.isArray(data)
        ? data
        : [];

      setPendingLeaveCount(results.filter((r) => r.status === "Pending").length);
      setTotalLeaveCount(results.length);
    } catch (error) {
      console.error("Error fetching leave requests:", error);
    }
  };

  // ================= WFH =================
  const fetchPendingWFHCount = async () => {
    try {
      const data = await apiClient("/wfh/requests/");
      if (!data) return;

      const results = Array.isArray(data.results)
        ? data.results
        : Array.isArray(data)
        ? data
        : [];

      setPendingWFHCount(
        results.filter((r) => r.status === "PENDING").length
      );
    } catch (error) {
      console.error("Error fetching WFH requests:", error);
    }
  };

  // ================= RESIGNATION =================
  const fetchResignationRequests = async () => {
    try {
      const data = await apiClient("/resignation/hr/");
      if (!data) return;

      const results = Array.isArray(data.results)
        ? data.results
        : Array.isArray(data)
        ? data
        : [];

      setPendingResignationRequests(
        results.filter((r) => r.status === "Pending").length
      );
    } catch (error) {
      console.error("Error fetching resignation requests:", error);
    }
  };

  // ================= SALARY SLIP =================
  const fetchSalarySlipRequests = async () => {
    try {
      const data = await apiClient("/salary-slip/list/");
      if (!data) return;

      const list = Array.isArray(data.results)
        ? data.results
        : Array.isArray(data)
        ? data
        : [];

      setPendingSalarySlipRequests(
        list.filter((r) => r.status === "Pending").length
      );
    } catch (error) {
      console.error("Error fetching salary slip requests:", error);
    }
  };

  // ================= EMPLOYEES =================
  const fetchEmployeeCount = async () => {
    try {
      const data = await apiClient("/auth/allemployees/");
      if (!data) return;

      const employees = Array.isArray(data.results)
        ? data.results
        : Array.isArray(data)
        ? data
        : [];

      setEmployeeCount(employees.length);
    } catch (error) {
      console.error("Error fetching employee count:", error);
    }
  };

  const features = [
    { title: "All Employees", count: employeeCount, color: "blue", path: "/dashboard/ManagerAcess/allemployees" },
    { title: "Leave Requests", count: pendingLeaveCount, color: "orange", path: "/dashboard/ManagerAcess/leaverequest" },
    { title: "Leave History", count: totalLeaveCount, color: "green", path: "/dashboard/ManagerAcess/leavehistory" },
    { title: "Salary-Slip Request", count: pendingSalarySlipRequests, color: "red", path: "/dashboard/ManagerAcess/salarysliprequestreview" },
    { title: "WFH Requests", count: pendingWFHCount, color: "purple", path: "/dashboard/leave/wfhrequestsPage" },
    { title: "CF Leave Approval", count: pendingCFLeaveCount, color: "pink", path: "/dashboard/ManagerAccess/cfleaveApproval" },
    { title: "Resignation", count: pendingResignationRequests, color: "pink", path: "/dashboard/ManagerAccess/hrresignationreviewPage" },
    { title: "Announcements", count: "", color: "teal", path: "/dashboard/ManagerAcess/hrannoucementpage" },
    { title: "Monthly Roster", count: "", color: "gray", path: "/dashboard/ManagerAccess/rosterpage" },
    { title: "Holidays", count: "", color: "gray", path: "/dashboard/ManagerAcess/hrholidays" },
    { title: "Awards", count: "", color: "gray", path: "/dashboard/ManagerAcess/Awards" },
    { title: "Carry Forward Leave", count: "", color: "blue", path: "/dashboard/ManagerAcess/carryforwardleave" },
  ];

  return (
    <div className="admin-dashboard-container">
      <h1 className="admin-dashboard-title">Admin Dashboard</h1>

      <div className="admin-card-grid">
        {features.map((feature, index) => (
          <div
            key={index}
            className={`admin-card admin-card-${feature.color}`}
            onClick={() => navigate(feature.path)}
          >
            <h2>{feature.title}</h2>
            <p>{feature.count !== "" ? feature.count : "→"}</p>
          </div>
        ))}
      </div>

      <SessionHandler />
    </div>
  );
};

export default AdminDashboard;
